/**
 * Открытые вакансии. Каждая запись — карточка на /jobs/ и страница /jobs/<slug>/.
 * Файл в CommonJS: его читает и gatsby-node (роуты, sitemap), и фронт.
 *
 * Необязательные секции (timeSplit, content, fit, about, team) можно не указывать —
 * на странице они просто не выведутся.
 */
module.exports = [
  {
    slug: 'seo-teamlead',
    title: 'Тимлид SEO',
    // Заголовок на странице: обычная часть + выделенная курсивом
    heading: ['Тимлид', 'SEO'],
    subtitle: 'в команду Performance Nimax',
    teamName: 'Nimax Performance',
    datePosted: '2026-10-01',
    city: 'Санкт-Петербург',
    remote: true,
    salaryFrom: 150000,
    experienceYears: 5,
    email: 'rabota@nimax.ru',
    emailSubject: 'SEO тимлид',
    // Кому писать, в дательном падеже: «Пришлите письмо Полине»
    recruiterTo: 'Полине',
    cover: '/images/jobs/seo-cover.jpg',

    seo: {
      title: 'Вакансия: тимлид SEO в Nimax Performance',
      description:
        'Ищем тимлида SEO с опытом от 5 лет: клиентские проекты, AI-пайплайны, команда SEO-специалистов. Удалённо или гибрид в Петербурге, оклад от 150 000 ₽.'
    },

    preview: {
      teaser:
        'Ищем специалиста, которому нравится глубоко разбираться в проектах и доводить идеи до результата. Около 70% времени — клиентские проекты, остальное — работа с командой SEO-специалистов.',
      tags: ['от 150 000 ₽ на руки', 'Удалённо / гибрид', 'Опыт от 5 лет']
    },

    facts: [
      ['от 150 000 ₽', 'на руки'],
      ['5+ лет', 'в сложных SEO-проектах'],
      ['Удалённо / гибрид', 'офис в Петербурге'],
      ['Старт с 9 до 11', 'по Москве']
    ],

    intro: {
      lead: 'Привет! Мы ищем специалиста, которому нравится глубоко разбираться в проектах, находить возможности для роста и доводить свои идеи до результата.',
      text: 'Здесь точно будет место вашим идеям и возможность проверить их на реальных задачах: улучшать работу с SEO-контентом, проверять подходы GEO/AEO и делать услугу сильнее.'
    },

    timeSplit: {
      heading: 'Как распределится время',
      text: 'Около 70% времени — клиентские проекты. Остальное — команда: вместе с SEO-специалистами разбирать кейсы и искать решения. Рядом будут руководитель отдела Наташа, SEO-специалисты и менеджеры. Можно обсуждать сложные вопросы, спорить о подходах и искать решение вместе.',
      items: [
        {
          share: 70,
          title: 'Клиентские проекты',
          text: 'Анализ, стратегия, техническая оптимизация, контент, внедрение и проверка результата. Это роль с большой долей практической работы и самостоятельности.'
        },
        {
          share: 30,
          title: 'Команда и развитие услуги',
          text: 'Работа с командой SEO-специалистов: разбирать проектные кейсы, вместе находить решения для развития проектов, следить за качеством и встречаться с клиентами вместе с сейлзами.'
        }
      ]
    },

    tasks: [
      {
        title: 'Вести проекты',
        text: 'Самостоятельно вести проекты: разбираться в задаче бизнеса, формировать стратегию, выбирать приоритеты, выполнять SEO-работы и оценивать результат.'
      },
      {
        title: 'AI-пайплайны и агенты',
        text: 'Разрабатывать AI-пайплайны в n8n и настраивать агентов: связывать сервисы через API, настраивать работу с LLM, проверять качество результата и обрабатывать ошибки.'
      },
      {
        title: 'Качество в команде',
        text: 'В выделенное время отслеживать качество и результаты проектов у своей команды: замечать отклонения, разбирать сложные вопросы и помогать определить, что нужно изменить или развить. Важно вовремя увидеть проблему и проверить, что корректировка сработала.'
      },
      {
        title: 'Встречи с клиентами',
        text: 'Участвовать с сейлзами в клиентских встречах: объяснять подход, защищать решения и помогать оценить необходимые работы.'
      }
    ],

    content: {
      heading: ['Про наш', 'SEO-контент'],
      text: 'Мы строим сильный процесс работы с текстами: от выбора темы и ТЗ до проверки материала и оценки его результата.',
      flow: ['Тема', 'ТЗ', 'Проверка материала', 'Оценка результата'],
      flagsText:
        'Важно понимать, что человек хочет найти по запросу, какая информация ему нужна и как содержание помогает решить задачу клиента. И уметь заметить:',
      flags: [
        'Поверхностный текст',
        'Неподтверждённое утверждение',
        'Потерянный смысл',
        'Формально по ТЗ, но мало полезно читателю'
      ]
    },

    requirements: {
      lead: 'Старшего специалиста с опытом самостоятельной работы со сложными SEO-проектами от 5 лет. Важно, чтобы за кейсами стояла ваша собственная практика и вы могли объяснить, какие решения принимали лично и как проверяли их эффект.',
      items: [
        'Опыт работы с крупными сайтами, большими объёмами семантики и контентными проектами — медиа или корпоративными блогами.',
        'Кейсы применения AI в работе и самостоятельного выстраивания автоматизаций.',
        'Понимание работы Яндекса и Google, сканирования, индексации, технической оптимизации и структуры сайта.',
        'Умение работать с аналитикой и вебмастерами, находить причины изменений и отделять наблюдение от гипотезы.',
        'Уверенное использование инструментов обхода сайтов, сбора семантики, конкурентов и выдачи. Конкретные сервисы могут отличаться от нашего набора.',
        'Техническая грамотность, которой хватает для содержательного разговора с разработчиками и проверки внедрения.',
        'Умение оценивать трудозатраты, выбирать приоритеты и обсуждать ограничения с клиентом.'
      ]
    },

    fit: [
      [
        'Следите за поиском',
        'Вам интересно, как меняется поиск: вы замечаете возможности, предлагаете идеи и сами проверяете их на проектах. Умеете организовать работу, разобраться в незнакомой задаче и вовремя попросить помощь.'
      ],
      [
        'С вами легко обсуждать',
        'Вы понятно объясняете сложное, слышите обратную связь и меняете подход, если данные ему противоречат. Замечаете детали, заранее говорите о рисках и честно показываете результаты.'
      ],
      [
        'Любите копать глубже',
        'Вам нравится глубоко разбираться в своей области, пробовать новое и видеть, как ваша работа делает проекты и агентство сильнее.'
      ],
      [
        'Умеете вести команду',
        'Вы умеете работать в команде — ставите задачи, растите людей и отвечаете за результат, а не только за свою часть работы.'
      ]
    ],

    about: {
      paragraphs: [
        'Nimax — digital-агентство, где мы объединяем экспертизу в перформанс, коммуникациях, брендинге и UX/UI-дизайне и вместе работаем над задачами клиентов.',
        'Мы внимательно работаем с техническим качеством сайта, структурой, удобством и контентом. Нам важно понимать, какую пользу приносит каждое изменение и что происходит дальше с привлечённой аудиторией: читает ли она материалы, интересуется ли продуктом, оставляет ли обращения.'
      ],
      clients: ['Okko', 'Газпром Нефть', 'Bausch & Lomb', 'Knauf', 'Совкомбанк', 'ATI.SU']
    },

    team: {
      photo: '/images/jobs/seo-team.jpg',
      photoAlt: 'Команда Nimax Performance',
      lead: 'Nimax Performance — команда, где можно увлечённо обсуждать поисковую выдачу, спорить о гипотезах и вместе разбираться, почему хорошая идея пока не сработала.',
      paragraphs: [
        'Здесь рядом работают специалисты по SEO, контексту, таргету — есть с кем подумать над задачей и посмотреть на неё под другим углом.',
        'Нам интересно, что происходит с бизнесом клиента после клика: находит ли человек нужное, оставляет ли заявку, возвращается ли за покупкой. Поэтому мы любим любопытных людей, точные вопросы и решения, пользу которых можно проверить.'
      ]
    },

    conditions: [
      ['Оклад', 'от 150 000 ₽ после налогов'],
      [
        'Формат',
        'Удалённая работа или гибрид с офисом в Санкт-Петербурге. Предпочтительно, чтобы вы находились в Петербурге, но рассматриваем кандидатов из регионов.'
      ],
      ['График', 'Полный рабочий день с гибким началом с 9:00 до 11:00 по московскому времени.'],
      ['Рост', 'Регулярные ревью и обратная связь.'],
      ['Обучение', 'Оплачиваем полностью небольшие курсы и на 50% — более серьёзные программы.'],
      ['Бонус', 'Дополнительный выходной в день рождения.']
    ],

    apply: {
      steps: [
        ['Резюме', 'и короткий рассказ о себе.'],
        [
          'Примеры проектов',
          '— какую задачу решали, что делали лично, по каким показателям оценивали результат и с какими ограничениями столкнулись.'
        ],
        ['Успешный кейс', 'внедрения AI в работу.']
      ],
      note: 'Если проект под NDA, достаточно обезличенного описания. Нам важно увидеть, как вы думаете, что умеете делать сами и каким результатом гордитесь.'
    }
  }
];
